import React from 'react';
import { HeaderTemplate, Stepper } from 'web-library';
import ExamRegistrationAndProfile from '../../modules/examRegistration/components/ExamRegistrationAndProfile';
import ExamTypeUuidDisplay from '../../modules/examRegistration/components/ExamTypeUuidDisplay';
import ExamTitle from '../../modules/examRegistration/components/ExamTitle';

interface ReviewExamPageProps {
  routeSteps: { label: string }[];
}

const ReviewExamPage = ({ routeSteps }: ReviewExamPageProps) => (
  <>
    <ExamTitle enableApi={false} />
    <HeaderTemplate>
      <ExamTypeUuidDisplay enableApi={false} />
      <div>
        <Stepper activeStep={3} steps={routeSteps} />
      </div>
    </HeaderTemplate>
    <ExamRegistrationAndProfile />
  </>
);

export default ReviewExamPage;
